<template>
  <el-container class="layout-container" :style="layoutStyle">
    <el-header class="layout-header" v-if="!noLayoutRoutes.includes($route.name) && !isAndroid">
      <Header ref="Header" />
    </el-header>
    <EventBanner
      v-if="showEventBanner"
      :date-text="eventBannerDateText"
      :activity-name="eventBannerActivityName"
      :tag="eventBannerTag"
      :content="eventBannerContent"
      :gradient="eventBannerGradient"
      :show-register="eventBannerCanRegister"
      :registering="registering"
      @detail="openEventDialog"
      @register="handleEventRegister"
    />
    <el-container class="layout-content" :class="{ 'layout-content-android': isAndroid }">
      <Aside
        v-if="!noLayoutRoutes.includes($route.name) && !isAndroid"
        @feedback="$refs.Header.handleFeedback()"
        @operationManual="$refs.Header.handleOperationManual()"
      />
      <Main />
    </el-container>

    <EventActivityDialog
      :visible="eventDialogVisible"
      :title="eventDialogTitle"
      :date-text="eventDialogDateText"
      :description="eventDialogDescription"
      :image="eventDialogImage"
      @update:visible="onEventDialogVisible"
      @confirm="onEventDialogConfirm"
      @close="onEventDialogConfirm"
    />
  </el-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Main from './components/Main'
  import Header from './components/Header'
  import Aside from './components/Aside'
  import EventBanner from '@/components/event-banner'
  import EventActivityDialog from '@/components/event-banner/event-activity-dialog'
  import { noLayoutRoutes } from '@/config'
  import { GlobalEventType } from '@/constants'
  import { isAndroid } from '@/utils/device'
  import i18n from '@/locale'
  export default {
    name: 'Layout',
    components: { Main, Header, Aside, EventBanner, EventActivityDialog },
    data() {
      return {
        isAndroid,
        noLayoutRoutes,
        registering: false,
      }
    },
    computed: {
      ...mapGetters({
        eventBannerVisible: 'eventBanner/visible',
        eventBannerDateText: 'eventBanner/dateText',
        eventBannerActivityName: 'eventBanner/activityName',
        eventBannerTag: 'eventBanner/tag',
        eventBannerContent: 'eventBanner/content',
        eventBannerGradient: 'eventBanner/gradient',
        eventDialogVisible: 'eventBanner/dialogVisible',
        eventDialogTitle: 'eventBanner/dialogTitle',
        eventDialogDateText: 'eventBanner/dialogDateText',
        eventDialogDescription: 'eventBanner/dialogDescription',
        eventDialogImage: 'eventBanner/dialogImage',
        eventBannerCanRegister: 'eventBanner/canRegister',
      }),
      showEventBanner() {
        return (
          this.eventBannerVisible &&
          !this.noLayoutRoutes.includes(this.$route.name) &&
          !this.isAndroid
        )
      },
      layoutStyle() {
        return {
          '--layout-extra-top': this.showEventBanner ? '48px' : '0px',
        }
      },
    },
    methods: {
      ...mapActions({
        openEventDialog: 'eventBanner/OPEN_EVENT_DIALOG',
        closeEventDialog: 'eventBanner/CLOSE_EVENT_DIALOG',
        registerEventActivity: 'eventBanner/REGISTER_ACTIVITY',
      }),
      async handleEventRegister() {
        if (this.registering) return
        this.registering = true
        try {
          const ok = await this.registerEventActivity()
          if (ok) {
            this.$mgMessage(i18n.t('报名成功'), 'success')
            // 通知收银购物车按最新报名状态重调总部券 hit
            this.$GlobalEventBus.emit(GlobalEventType.REFRESH_HQ_COUPON)
          }
        } catch (error) {
          console.error('TIPS register activity error:', error)
        } finally {
          this.registering = false
        }
      },
      onEventDialogVisible(val) {
        if (!val) {
          this.closeEventDialog()
        }
      },
      onEventDialogConfirm() {
        this.closeEventDialog()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .layout-container {
    .layout-header {
      height: $mg-layout-header-height !important;
      box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
      background: #fff;
      position: relative;
      z-index: 12;
    }
    .layout-content {
      height: $mg-layout-content-height;
      // 2026-09-15 原写法：无 overflow
      // 原因：左侧菜单项过多时 overflow:visible 会撑出整页滚动，右侧 HQEvent 按视口高度算，往下滚后列表区显得没铺满；加 overflow:hidden 把滚动限制在侧栏内
      // overflow: visible; // 原默认行为
      overflow: hidden;
    }
    .layout-content-android {
      height: 100vh !important;
    }
  }
</style>
